/* eslint-disable max-lines-per-function */
/* eslint-disable @typescript-eslint/prefer-readonly-parameter-types */
/* eslint-disable react/forbid-elements */
import { FC } from "react";
import { createPortal } from "react-dom";
import { useLocation } from "../hooks/useLocation";
import { useLanguageUrlParam } from "../hooks/useLanguageUrlParam";
import { t } from "../miscellaneous/t";
import { getPartnerPathnameClient } from "../../getPartnerPathnameClient";
import { useSettingsValueData } from "../../app/hooks/useSettingsValueData";
import { setupPageTitle } from "../../app/miscellaneous/setupPageTitle";
import { BreadCrumbsLanguageTab } from "./BreadCrumbsLanguageTab";
import { Container } from "../../app/components/Container";
import { cartFlowSequence } from "../miscellaneous/cartFlowSequence";
import { useToastsScrollRef } from "../../app/hooks/useToastsScrollRef";
import { useToastPositionEffect } from "../hooks/useToastPositionEffect";
import { BreadCrumbsCurrencyTab } from "./BreadCrumbsCurrencyTab";

export const BreadCrumbs: FC = () => {
  const breadCrumbsElement = document.getElementById("mkhc-breadcrumbs");
  const { pathname } = useLocation();
  const langUrlParam = useLanguageUrlParam();

  const pageTitle = setupPageTitle(pathname);

  const settings = useSettingsValueData();
  const partnerProductsUrl =
    settings.data.pageIntegration?.partnerLinks?.productsPageUrl;

  const ref = useToastsScrollRef();

  const showBreadCrumbs =
    cartFlowSequence
      .filter((page) => page.path !== "/success")
      .some(
        (page) => `${getPartnerPathnameClient(true)}${page.path}` === pathname
      ) &&
    breadCrumbsElement !== null &&
    settings.tag === "ready";

  useToastPositionEffect(showBreadCrumbs);

  return showBreadCrumbs
    ? createPortal(
        <div ref={ref} className="tw-bg-gray-300 print:tw-hidden">
          <Container className="!tw-py-0 tw-flex  tw-justify-between">
            <div className="tw-flex">
              <div
                className="mkhc-hover-link-container"
                id="mkhc-shopping-cart-link"
              >
                <a
                  className="mkhc-hover-link tw-flex"
                  href={`${getPartnerPathnameClient(
                    true
                  )}/purchases${langUrlParam}`}
                  aria-label={t("mk-hc-back-to-cart")}
                >
                  <div
                    id="mkhc-shopping-cart-icon"
                    className="fa-solid fa-cart-shopping tw-text-secondary tw-mr-2 tw-w-3 tw-h-3 tw-self-center"
                  ></div>
                  <span className="!tw-font-medium tw-self-start tw-whitespace-nowrap">
                    {t("mk-hc-cart-title")}
                  </span>
                </a>
              </div>
              <div className="tw-mx-1 tw-pt-1 tw-min-tw-h-full tw-flex">
                <span className="tw-text-sm tw-font-medium !tw-text-gray-600 tw-self-center tw-whitespace-nowrap">
                  {pageTitle}
                </span>
              </div>
            </div>
            <div className="tw-flex tw-w-[30%] tw-justify-end">
              <div
                id="mkhc-products-page-link"
                className="mkhc-hover-link-container"
              >
                <a className="mkhc-hover-link" href={partnerProductsUrl}>
                  <span className="tw-font-medium tw-whitespace-nowrap">
                    {t("mk-hc-products-page")}
                  </span>
                </a>
              </div>
              <BreadCrumbsLanguageTab />
              <BreadCrumbsCurrencyTab />
            </div>
          </Container>
        </div>,
        breadCrumbsElement
      )
    : null;
};
